import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import { PosTestIds } from '../../../utils/testIds/Pos.testIds';
import { useTranslation } from '../../translation/TranslationContext';
import usePosForm from '../hooks/usePosForm';
import PosAutocomplete from './PosAutocomplete';

const PosForm = () => {
  const { translate } = useTranslation();
  const { control, isSubmitting, handleValidSubmit, handleAnswerLater } = usePosForm();

  return (
    <Box sx={{ width: 320, maxWidth: '100%' }}>
      <form onSubmit={handleValidSubmit}>
        <Box sx={{ pb: 2 }}>
          <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
            {translate(LangEnum.POS_SUBTITLE)}
          </Typography>
        </Box>

        <PosAutocomplete control={control} name="pointOfSale" />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, pt: 4 }}>
          <Button
            variant="contained"
            color="secondary"
            size="medium"
            disabled={isSubmitting}
            testId={PosTestIds.SEND_LATER_BUTTON}
            onClick={handleAnswerLater}
          >
            {translate(LangEnum.GLOBAL_SEND_REPLY_LATER)}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            type="submit"
            loading={isSubmitting}
          >
            {translate(LangEnum.GLOBAL_ANSWER_BUTTON_LABEL)}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default PosForm;
